import React from 'react'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconList } from '../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { useApiListSelfRegister } from '../../../../../api-new/state/content'
import { Menu, MenuPurge, MenuRestore } from '../../../../../shared/menu/menu'
// import { useRoleOrgTradeshow } from '../../../../../role/hook/role-org'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { ColumnText, ColumnMenu } from '../../../../../shared/table-builder/table-columns'
import { recycleErrorMessage } from '../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../shared/error/use-error-line'

export function SelfRegisterRecycle() {
  const apiListSelfRegister = useApiListSelfRegister()

  // const roleOrgTradeshow = useRoleOrgTradeshow()

  const [error, failure, setError] = useErrorLine()

  const handleReady = async () => await apiListSelfRegister.get('deleted')
  const handleDestroyed = () => apiListSelfRegister.init()

  const handleRestore = async tradeshow => {
    setError(null)
    try {
      await apiListSelfRegister.put(`${tradeshow.id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That item was already removed.'), err)
    }
    await apiListSelfRegister.get('deleted')
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="recycle bin">
        <CardFullHeightScrollY title="recycle bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListSelfRegister} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row)} show={true} pin />
                  <MenuPurge to={`/org/self-register/list/recycle/purge/${row.id}`} show={true} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
